var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2827 8.96012L15.0401 4.71748L17.111 2.64658C17.6968 2.0608 18.6465 2.0608 19.2323 2.64658L21.3536 4.7679C21.9394 5.35369 21.9394 6.30344 21.3536 6.88923L19.2827 8.96012Z",
    fill: "#6F757C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30777 13.4491L6.30777 17.6918L10.5504 17.6917L17.9188 10.3233L16.5046 8.90905L9.72196 15.6917L8.30777 15.6918L8.30777 14.2775L15.0904 7.49484L13.6762 6.08063L6.30777 13.4491Z",
    fill: "#6F757C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.36329C4 5.81101 4.44772 5.36329 5 5.36329H11.3184V3.36329H5C3.34315 3.36329 2 4.70644 2 6.36329V19C2 20.6569 3.34315 22 5 22H17.6367C19.2936 22 20.6367 20.6569 20.6367 19V12.6817H18.6367V19C18.6367 19.5523 18.189 20 17.6367 20H5C4.44772 20 4 19.5523 4 19V6.36329Z",
    fill: "#6F757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c883662019f29c5ab75b8b52158f58be.svg";
export { ForwardRef as ReactComponent };